import { Tooltip, IconButton, SxProps } from "@mui/material";
import { IconTypes } from "../icons.types";
import { trackEvent } from "../../features/analytics/analytics";

const HelpButton = ({
  helpUrl,
  title,
  size,
  sx,
  outlined = true,
  color,
}: {
  helpUrl?: string;
  title?: string;
  size?: "small" | "large";
  sx?: SxProps;
  outlined?: boolean;
  color?: string;
}) => {
  if (!helpUrl) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    trackEvent({ category: "help", action: "click", label: helpUrl });
    window.open(helpUrl, "_blank");
  };

  return (
    <Tooltip title={title || "Learn more"}>
      <IconButton
        sx={{
          color: color || "text.secondary",
          "&:hover": { color: "primary.main" },
          ...sx,
        }}
        onClick={handleClick}
      >
        {outlined ? (
          <IconTypes.HelpOutline fontSize={size} />
        ) : (
          <IconTypes.Help fontSize={size} />
        )}
      </IconButton>
    </Tooltip>
  );
};
export default HelpButton;
